import { render, staticRenderFns } from "./WidgetDictionaryEntries.vue?vue&type=template&id=6b492b64&"
import script from "./WidgetDictionaryEntries.vue?vue&type=script&lang=js&"
export * from "./WidgetDictionaryEntries.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDictionaryEntries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetDictionaryEntries.vue"
export default component.exports